import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  create_user_management_data,
  user_management_computed,
  build_edit_form,
  get_project_display_name
} from './user_management_helpers';
import { user_management_core_methods } from './user_management_core_methods';
import { user_management_action_methods } from './user_management_action_methods';

export default {
  name: 'UserManagement',
  build_edit_form,
  get_project_display_name,
  mixins: [alert_mixin],
  data: create_user_management_data,
  mounted() {
    this.fetch_users();
    this.fetch_roles();
  },
  computed: user_management_computed,
  methods: {
    ...user_management_core_methods,
    ...user_management_action_methods
  }
};
